'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002440 from "./presto.-Agent-View$$anon$40.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$39() {
  this.azp = null;
  this.azn = null;
  this.azo = false;
  this.azl = null;
  this.azm = false;
  this.azq = false;
  this.azr = false;
  this.azp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$39 as $c_Lpresto_AgentView$$anon$39 };
$p = $c_Lpresto_AgentView$$anon$39.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$39;
/** @constructor */
function $h_Lpresto_AgentView$$anon$39() {
}
export { $h_Lpresto_AgentView$$anon$39 as $h_Lpresto_AgentView$$anon$39 };
$h_Lpresto_AgentView$$anon$39.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.azp;
});
$p.t = (function() {
  if ((!this.azo)) {
    this.azn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("files", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.azo = true;
  }
  return this.azn;
});
$p.ae = (function() {
  if ((!this.azm)) {
    this.azl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().p9(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002440.$c_Lpresto_AgentView$$anon$40()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.azm = true;
  }
  return this.azl;
});
$p.w = (function() {
  if ((!this.azr)) {
    this.azq = false;
    this.azr = true;
  }
  return this.azq;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_AgentView$$anon$39 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$39, "presto.AgentView$$anon$39", ({
  E4: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$39 as $d_Lpresto_AgentView$$anon$39 };
//# sourceMappingURL=presto.-Agent-View$$anon$39.js.map
